export enum MapMessage {
  INTERACT = 'interact',
  SELECTED_GUID = 'selectedGuid',
  SELECTED_PIN = 'selectedPin',
  CLOSED = 'closed'
}
